(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
    let blog = document.querySelector('.main-blog');
    let className = blog.querySelector('.container').getAttribute('data-section-class');
    blog.classList.add(className)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
// Shortcircuit variable
let triggered = false;

function ScrollExecute() {
    // Locate loadmore button
    let moreButton = jQuery('#more').last();

    // Get URL from the loadmore button
    let nextUrl = jQuery(moreButton).find('a').attr("href");

    // Button position when AJAX call should be made one time
    if (jQuery(moreButton).length > 0 && ((jQuery(moreButton).offset().top - jQuery(window).scrollTop()) < 800) && (triggered == false)) {

        // Trigger shortcircuit to ensure AJAX only fires once
        triggered = true;

        // Make ajax call to next page for load more data
        jQuery.ajax({
            url: nextUrl,
            type: 'GET',
            beforeSend: function() {
                moreButton.remove();
            }
        }).done(function(data) {
            jQuery('#searchresults').append(jQuery(data).find('#searchresults').html());
            AOS.init()
            // On success, reset shortcircuit
            triggered = false
        });
    }
}

jQuery(document).ready(function () {
    jQuery(window).scroll(function(){
        ScrollExecute();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);
    const url = productRecommendationsSection.dataset.url;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          jQuery(productRecommendationsSection).html(jQuery(recommendations).html());
        }
      })
      .then(()=>{
        jQuery('.slider-products').slick('unslick');
        initSliderArrivals();
        setTimeout(()=>{
          AOS.init();
        }, 3000)
      })
      .catch(e => {
        console.error(e);
      });
  };
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-form"] && !Shopify.designMode) return;
  try {
    
    let blog = document.querySelector('.contact');
    let className = blog.querySelector('.container').getAttribute('data-section-class');
    blog.classList.add(className)

  } catch(e) { console.error(e); }
})();
})();
